var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"order profile"},[_c('StandingOrder',{attrs:{"orders":_vm.orders,"ordersLength":_vm.ordersLength},on:{"removeItem":_vm.removeStandingOrder}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }